import {
  BILLING_ITEM_TYPE_LABELS,
  PAYMENT_STATUS_LABELS,
  PERIODICITY_LABELS,
  RENEWAL_STATUS_LABELS,
} from "../data/subscriptionOptions";

import {
  parseSubscriptionDate,
} from "./subscriptionDates";

export const formatSubscriptionMoney = (
  value,
  {
    maximumFractionDigits = 2,
    minimumFractionDigits = 2,
  } = {},
) =>
  Number(value || 0).toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits,
    minimumFractionDigits,
  });

export const formatSubscriptionDate = (
  value,
  fallback = "Non renseignée",
) => {
  const date = parseSubscriptionDate(value);

  if (!date) return fallback;

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatShortSubscriptionDate = (
  value,
  fallback = "—",
) => {
  const date = parseSubscriptionDate(value);

  if (!date) return fallback;

  return date.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "short",
    year: "2-digit",
  });
};

export const formatSubscriptionPeriod = (
  startDate,
  endDate,
) => {
  if (!startDate && !endDate) {
    return "Période non renseignée";
  }

  if (startDate && !endDate) {
    return `Depuis le ${formatSubscriptionDate(startDate)}`;
  }

  if (!startDate && endDate) {
    return `Jusqu’au ${formatSubscriptionDate(endDate)}`;
  }

  return `${formatSubscriptionDate(
    startDate,
  )} → ${formatSubscriptionDate(endDate)}`;
};

export const getAssociationName = (subscription) =>
  subscription?.Association?.nom_asso ||
  subscription?.association?.nom_asso ||
  subscription?.nom_asso ||
  `Association #${subscription?.asso_id || "—"}`;

export const getBillingItemTypeLabel = (itemType) =>
  BILLING_ITEM_TYPE_LABELS[itemType] || "Abonnement annuel";

export const getPeriodicityLabel = (periodicity) =>
  PERIODICITY_LABELS[periodicity] ||
  periodicity ||
  "Non renseignée";

export const getPaymentStatusLabel = (status) =>
  PAYMENT_STATUS_LABELS[status] || "État inconnu";

export const getRenewalStatusLabel = (status) =>
  RENEWAL_STATUS_LABELS[status] || "État inconnu";

export const formatProgressPercentage = (value) =>
  `${Math.round(Number(value || 0))} %`;